<template>
  <div v-if="landingPageData">
    <main-section
      :meta-info="metaInfo"
      :section-id="landingPageData.pageId"
      :title="landingPageData.title"
      :sub-title="landingPageData.tagLine"
      :icon-class="landingPageData.iconClass"
      :image-url="landingPageData.heroImage"
      :sections="landingPageData.sections"
      :hasHeroOverlay="true"
      :noSearchBar="!landingPageData.hasSearchBar"
      :isSmallHero="landingPageData.isSmallHero"
      :hasAgencySearchBar="landingPageData.hasAgencySearchBar"
    ></main-section>
  </div>
  <loading v-else-if="isPending"></loading>
  <error-message v-else-if="error" class="error" :retry="true"></error-message>
</template>
<script setup lang="ts">
import { computed, watch } from 'vue';
import useSafeRoute from '@/app/composables/useSafeRoute';
import { useLandingPageDataNew } from '@/app/data/useLandingPagesDataNew';
import config from '@/config';
import utils from '@/app/utils/utils';
import MainSection from '@/app/components/main-section/main-section.vue';
import Loading from '@/app/components/loading/loading.vue';
import ErrorMessage from '@/app/components/error-message/error-message.vue';
import isSSR from '@/utils/isSSR';
import * as actions from '@/app/store/action-types';
import { useStore } from 'vuex';

const route = useSafeRoute();
const page = computed(() => route.value?.path.replace('/', '') || config.LANDING_PAGES.DEFAULT);

const { data: landingPageData, isPending, error } = useLandingPageDataNew(page);
const metaInfo = computed(() => {
  return landingPageData.value
    ? {
        title: landingPageData.value.title,
        meta: utils.getMetaTagsForPage(
          landingPageData.value.title,
          landingPageData.value.metaDescription,
          landingPageData.value.heroImage
        ),
        link: [{ rel: 'canonical', href: `${config.FRONT.PROD_BASE_URL}${route.value?.path}` }],
      }
    : undefined;
});

const store = useStore();

watch(
  landingPageData,
  (newVal) => {
    if (!isSSR && newVal?.pageName) {
      void store.dispatch(actions.analytics.set, {
        pageName: `etusivu:${newVal.pageName}`,
        eVar17: newVal.title,
      });
      void store.dispatch(actions.analytics.track, config.analytics.eventTypes.pageView);
    }
  },
  { deep: true, immediate: true }
);
</script>
